export const SWIPE_THRESHOLD = 40
export const SWIPABLE_ZOOM_THRESHOLD = 1.2
